import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { addToCart } from "./CartService";

const PharmacyView = () => {
  const [activeTab, setActiveTab] = useState("description");
  const [quantity, setQuantity] = useState(1);

  const increaseQuantity = () => setQuantity((prev) => prev + 1);
  const decreaseQuantity = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  const handleAddToCart = () => {
    const newItem = {
      id: Date.now(),
      name: "Nutrilite Memory Builder Dietary",
      quantity: quantity,
    };
    addToCart(newItem);
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const tabs = [
    { id: "description", label: "Description" },
    { id: "additional", label: "Additional information" },
    { id: "reviews", label: "Reviews (2)" },
  ];

  const productInfo = {
    title: "Nutrilite Memory Builder Dietary",
    price: "$137.00",
    oldPrice: "$196.48",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
    sku: "N/A-250",
    categories: ["Diabetes", "Eyewear", "Health Conditions"],
    tags: ["Fruits", "Healthy"],
  };

  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
    marginTop: "20px",
  };

  const thTdStyle = {
    border: "1px solid #ddd",
    padding: "12px",
    textAlign: "left",
    fontSize: "15px",
    color: "#444",
  };

  const reviewsData = [
    {
      name: "CHUNG PHAM",
      date: "21-Oct-2020",
      rating: 4,
      content:
        "I am 6 feet tall and 220 lbs. This shirt fit me perfectly in the chest and shoulders. My only complaint is that it is so long! I like to wear polo shirts untucked...",
    },
    {
      name: "KENNETH R. MYERS",
      date: "21-Oct-2020",
      rating: 2,
      content:
        "The shirt was not the fabric I believed it to be. It says Classic Fit but was made like the older versions, not the soft cotton like my others.",
    },
  ];

  const StarRating = ({ rating }) => {
    const totalStars = 5;
    return (
      <div style={{ color: "#f5a623", fontSize: "18px" }}>
        {[...Array(totalStars)].map((_, index) => (
          <span key={index}>{index < rating ? "★" : "☆"}</span>
        ))}
      </div>
    );
  };

  return (
    <div
      style={{
        padding: "30px",
        fontFamily: "'Poppins', sans-serif",
        maxWidth: "850px",
        margin: "5px auto",
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
      }}
    >
      {/* ---------- Product Header ---------- */}
      <h1
        style={{
          fontSize: "1.8rem",
          fontWeight: "700",
          marginBottom: "10px",
          color: "#222",
        }}
      >
        {productInfo.title}
      </h1>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        {[...Array(4)].map((_, i) => (
          <FaStar key={i} color="#ffc107" />
        ))}
        <span style={{ color: "#777", fontSize: "14px" }}>
          (4 customer reviews)
        </span>
      </div>

      <div
        style={{
          fontSize: "1.6rem",
          fontWeight: "700",
          color: "#4e9b6c",
          marginBottom: "16px",
        }}
      >
        {productInfo.price}{" "}
        <span
          style={{
            textDecoration: "line-through",
            color: "#999",
            fontSize: "1rem",
            marginLeft: "6px",
          }}
        >
          {productInfo.oldPrice}
        </span>
      </div>

      <p style={{ color: "#555", marginBottom: "24px", lineHeight: "1.7" }}>
        {productInfo.description}
      </p>

      <div style={{ marginBottom: "30px", color: "#444", fontSize: "15px" }}>
        <p>
          <strong>SKU:</strong> {productInfo.sku}
        </p>
        <p>
          <strong>Categories:</strong> {productInfo.categories.join(", ")}
        </p>
        <p>
          <strong>Tags:</strong> {productInfo.tags.join(", ")}
        </p>
      </div>

      {/* ---------- Tabs ---------- */}
      <div
        style={{
          display: "flex",
          gap: "24px",
          borderBottom: "2px solid #e6e6e6",
          marginBottom: "20px",
        }}
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              cursor: "pointer",
              background: "none",
              border: "none",
              fontWeight: activeTab === tab.id ? "600" : "500",
              color: activeTab === tab.id ? "#2e6b4a" : "#555",
              fontSize: "16px",
              paddingBottom: "10px",
              borderBottom:
                activeTab === tab.id ? "3px solid #2e6b4a" : "3px solid transparent",
              transition: "all 0.3s ease",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* ---------- Tab Content ---------- */}
      <div style={{ color: "#555", lineHeight: "1.8" }}>
        {activeTab === "description" && (
          <>
            <p>
              Neuriva Brain Performance is a rather new supplement to hit the
              market. Despite a rather thin ingredient list, the product has seen
              a lot of buzz from its customers...
            </p>
            <p>
              When looking for an effective brain health supplement, you’ll want
              to see a healthy mix of ingredients like fish oil, resveratrol,
              Phosphatidylserine, Acetyl-L Carnitine, Ginkgo Biloba, bacopa
              monnieri, and Rhodiola Rosea.
            </p>
            <h3 style={{ marginTop: "30px", color: "#333" }}>Product Features</h3>
            <ul style={{ marginLeft: "20px", marginTop: "10px", lineHeight: "1.8" }}>
              <li style={{ marginBottom: "14px" }}>
                <strong>01. POWERS 5 INDICATORS OF BRAIN PERFORMANCE:</strong>{" "}
                The ingredients of Neuriva support 5 different indicators of brain
                performance: focus, memory, learning, accuracy and concentration.
              </li>
              <li style={{ marginBottom: "14px" }}>
                <strong>02. CLINICALLY PROVEN NATURAL INGREDIENTS:</strong>{" "}
                Clinical studies have shown that coffee cherry and PS enhance brain
                performance.
              </li>
              <li>
                <strong>03. NEUROFACTOR, A POWERFUL EXTRACT:</strong>{" "}
                Neurofactor increases levels of BDNF, supporting neuron survival and
                growth.
              </li>
            </ul>

          </>
        )}

        {activeTab === "additional" && (
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thTdStyle}>Specification</th>
                <th style={thTdStyle}>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={thTdStyle}>Stand Up</td>
                <td style={thTdStyle}>35″L x 24″W x 37-45″H</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Frame</td>
                <td style={thTdStyle}>Aluminum</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Weight Capacity</td>
                <td style={thTdStyle}>60 LBS</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Color</td>
                <td style={thTdStyle}>Gray, Yellow</td>
              </tr>
            </tbody>
          </table>
        )}

       {activeTab === "reviews" && (
  <div>
    <h1>Customer Reviews</h1>
    {reviewsData.map((review, index) => (
      <div key={index} style={{ borderBottom: "1px solid #ccc", marginBottom: "20px", paddingBottom: "10px" }}>
        <StarRating rating={review.rating} />
        <p style={{ fontSize: "14px", marginTop: "10px" }}>{review.content}</p>
        <div style={{ fontWeight: "bold", marginTop: "10px" }}>— {review.name}</div>
        <div style={{ fontSize: "12px", color: "#888" }}>{review.date}</div>
      </div>
    ))}
  </div>
)}

      </div>
    </div>
  );
};

export default PharmacyView;
